module.exports = __webpack_public_path__ + "img/2023.f9dee6de.png";